import { ReactNode, useEffect, useState } from "react";
import { initialState, LoanDashboardContext } from "./LoanDashboard.context";
import { ILoan } from "@/types/loan.type";
import { getLoanById, updateLoan } from "@/common/services/loans.api";

type Props = {
  children: ReactNode,
  loanId: string
}

export function LoanDashboardProvider(props: Props) {

  const [loan, setLoan] = useState<ILoan>(initialState.loan)

  useEffect(() => {
    async function loadLoan(loanId: string) {
      const result = await getLoanById(loanId)

      if (result.ok) {
        setLoan(result.data as ILoan)
      }
    }

    loadLoan(props.loanId)
  }, [props.loanId])

  async function saveLoan(dataToSave: ILoan) {
    try {
      const { ok, data, errors } = await updateLoan(loan._id as string, dataToSave)

      if (ok && data) {
        setLoan(data as ILoan)
        return { ok, data: data as ILoan, errors: (errors as [{ message: string, path: string[] }]) }
      }

      return { ok, data: data as ILoan, errors: errors as [{ message: string, path: string[] }] }
    } catch (err) {
      console.log(err)

      return {
        ok: false,
        data: dataToSave,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        errors: [{ message: (err as any).message, path: [] }]
      }
    }
  }

  const theState = { loan, saveLoan }

  return (
    <LoanDashboardContext.Provider value={theState}>
      {props.children}
    </LoanDashboardContext.Provider>
  )
}